// @flow
/** @jsx jsx */

import { jsx } from '@emotion/core';
import { Button, ButtonGroup } from '@zapier/common-components';

type Props = {
  /** Submit button text */
  buttonText?: string,
  /** Enable submit button */
  canSubmit?: boolean,
  /** Show cancel button */
  hasCancelButton?: boolean,
  /** Show busy indicator on submit button */
  isBusy?: boolean,
  /** On cancel */
  onCancel: () => void,
};

const PaymentFormButtons = (props: Props) => (
  <ButtonGroup
    direction="row"
    isFlex={false}
    justify="flex-end"
    margin="top"
    propsQueries={{
      phoneOnly: {
        isReversed: true,
        direction: 'column',
      },
    }}
  >
    {props.hasCancelButton && (
      <Button
        backgroundType="clear"
        color="secondary"
        onClick={props.onCancel}
        type="button"
      >
        Cancel
      </Button>
    )}
    <Button
      color="primary"
      isDisabled={!props.canSubmit}
      isMinWidth={true}
      isWorking={props.isBusy}
      type="submit"
    >
      {props.buttonText}
    </Button>
  </ButtonGroup>
);

PaymentFormButtons.defaultProps = {
  buttonText: 'Save',
};

export default PaymentFormButtons;
